import React from "react";

const SocialMedia = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px", color: "#FFFFFF" }}>
      <h2>Redes Sociales</h2>
      <ul style={{ listStyle: "none", padding: 0 }}>
        <li>
          <a
            href="https://www.linkedin.com/in/fernando-aguirre-fs/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#0077b5",
              fontSize: "50px",
            }}
          >
            LinkedIn
          </a>
        </li>
        <li>
          <a
            href="https://github.com/fernandoafsa"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#333", fontSize: "50px" }}
          >
            GitHub
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialMedia;
